<script setup>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    pageName: 'shopCoupons'
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)
const shopUid = computed(() => route.params?.shopUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

// Initial fetch (consumer) coupons
const bearerToken = useState('state_bearerToken')
const oid = useState('state_userOid')

const { data: couponsData, suspense: couponListSuspense, isPlaceholderData: isCouponsPlaceholderData } = useFetchCoupons({
    centerRoute: centerRoute.value,
    shopUid: shopUid.value,
    bearerToken,
    oid
})

onServerPrefetch(async () => {
    await centerDetailSuspense()
    await couponListSuspense()
})

// Auth
const authStore = useAuthStore()
const { isLoggedIn } = storeToRefs(authStore)

//  Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Get config
const couponListConfig = computed(() => {
    return {
        placeholder: isCouponsPlaceholderData.value,
        items: couponsData.value,
    }
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.COUPONS_OVERVIEW,
    centerUid: centerDetails.value?.centerUid,
    centerName: centerDetails.value?.centerName,
    loginStatus: isLoggedIn.value ? TRACKING_CONSTANTS.MISC.LOGGED_IN : TRACKING_CONSTANTS.MISC.LOGGED_OUT
})

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.header_navigation_goodies_web} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <CenterHeader />
        <CouponList :coupon-list-config="couponListConfig" />
    </PageMainContainer>
</template>
